import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {QuestionInput} from '../question-input';
import {TextQuestion} from '../../model/questions/text-question';
import {NumberQuestion} from '../../model/questions/number-question';
import {FIELD_TYPES} from "../../config/fieldTypes.config";
import {DATA_MASKS} from "../../config/dataMasks.config";

@Component({
  selector: 'app-input-number',
  templateUrl: './input-number.component.html',
  styleUrls: ['./input-number.component.scss'],
})
export class InputNumberComponent extends QuestionInput implements OnInit, AfterViewInit {

  @ViewChild('inputField', {static: false})
  inputField: ElementRef;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.questionAnswered.emit(this.question.answer != null);
    });
  }

  valueChange($event) {
      const charCode = ($event.which) ? $event.which : $event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false;
      }

      let value = $event.target.value;

      this.questionAnswered.emit(!!value);
  }


  get answer(): any {
    return (this.inputField.nativeElement as HTMLInputElement).value;
  }

    getTitle() {
      let title = '';
      if(this.question.answer){
          title = this.question.answer;
      }

      return title;
    }

    isPhoneType() {
      if(this.question.fieldType === FIELD_TYPES.phone){
        return true;
      }

      return false;
    }

    isDollarType() {
      if(this.question.fieldType === FIELD_TYPES.dollar){
        return true;
      }

      return false;
    }

    onInput(e) {
      const answerLength = this.question.answerLength;
      const inputValue = e.target.value;
      const inputValueLength = this.question.fieldType === FIELD_TYPES.number ? inputValue.replace(/\s/g, '').length : inputValue.length;

      if(answerLength) {
        if (inputValueLength > answerLength) {
          e.target.value = inputValue.slice(0, answerLength);
        }
        this.disableSubmitIfNotEnoughLength(e.target.value);
      }
    }

    disableSubmitIfNotEnoughLength(inputValue: string) {
      const answerLength = this.question.answerLength;
      // if (answerLength <= inputValue.length) {
        this.questionAnswered.emit(!!inputValue);
      // } else {
      //   this.questionAnswered.emit(false);
      // }
    }

  getFieldTitle() {
    if (this.hasUnitsIsch()) {
      return this.question.fieldTitle;
    }
  }

  hasUnitsIsch() {
    return this.question.fieldTitle && this.question.fieldTitle !== '';
  }

  getInputMask() {
    let mask = '';

    for (let i = 0; i < this.question.answerLength; i++) {
      mask += '0';
    }

    if (this.isPhoneType()) {
      mask = DATA_MASKS.phone;
    }

    if (this.isDollarType()) {
      mask = 'separator.2';
    }

    return mask;
  }

}
